// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportRangeSelector_wrapper__4Mubb","button":"ReportRangeSelector_button__X8gd4","active":"ReportRangeSelector_active__t-ON2"};